<template>
  <section
    class="positioner"
  >
    <fps-looker />
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { FpsLooker } from '@powerplay/core-minigames-ui'

export default defineComponent({
  name: 'FpsLookerComponent',
  components: {
    FpsLooker
  }
})
</script>

<style lang="less" scoped>
  .positioner {
    position: absolute;
    left: 50%;
    top: 0;
    width: 30%;
    height: 10%;
    pointer-events: auto;
    transform: translate(-50%);
  }
</style>
